import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { ContentTreeIconSpacing } from '../src/ContentTreeIcon.tsx';
import type { ContentTreeTypes } from './contentTreeTypes.ts';
export { ContentTreeIcon } from '../src/ContentTreeIcon.tsx';

export const ContentTreeIconLoader: LoadableType<{
	label: string;
	color?: string;
	spacing?: ContentTreeIconSpacing;
	type: ContentTreeTypes;
	isExpanded?: boolean;
	isMarkdownMode?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTreeIcon" */ '../src/ContentTreeIcon.tsx'))
			.ContentTreeIcon,
});
